import { render, staticRenderFns } from "./InvoiceReport.vue?vue&type=template&id=061ff8f9&scoped=true"
import script from "./InvoiceReport.vue?vue&type=script&lang=js"
export * from "./InvoiceReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061ff8f9",
  null
  
)

export default component.exports